/* <rr-gallery> — la galería del PDP enseña solo las fotos de la variante
   elegida. Los grupos los arma Liquid (uno por valor de la primera opción);
   aquí solo se cambia cuál está visible al oír rr:variant. Las fotos que no
   se ven no se descargan: siguen en lazy hasta que les toca.
   Cuando la galería CAMBIA (otra piedra), la página sube arriba del todo para
   que se vea la primera foto de la variante nueva (Cesar, 27 sep 2026), salvo
   que esa foto ya se vea: en móvil va justo encima del nombre y del selector
   (R-03, 15 oct 2026), y subir alejaría del botón de compra. Si solo cambia la
   talla las fotos son las mismas y no se mueve nada. */
(() => {
  if (customElements.get('rr-gallery')) return;

  class RRGallery extends HTMLElement {
    connectedCallback() {
      this.groups = [...this.querySelectorAll('[data-rr-media-group]')];
      if (this.groups.length < 2) return;
      this.onVariant = (e) => this.show(e.detail?.variant?.options?.[0]);
      document.addEventListener('rr:variant', this.onVariant);
    }

    disconnectedCallback() {
      if (this.onVariant) document.removeEventListener('rr:variant', this.onVariant);
    }

    show(value) {
      if (!value) return;
      const match = this.groups.find((g) => g.dataset.rrMediaGroup === value);
      // ya visible: la variante cambió dentro de la misma tanda (p. ej. la talla)
      if (!match || !match.hidden) return;
      this.groups.forEach((g) => {
        g.hidden = g !== match;
      });
      // la primera foto del grupo nuevo: si más de media queda por encima de
      // la pantalla, se sube; si se ve, no se mueve nada
      const lead = match.querySelector('.rr-pdp__tile');
      const box = lead ? lead.getBoundingClientRect() : null;
      if (window.scrollY > 0 && (!box || box.top < -box.height / 2)) {
        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: still ? 'auto' : 'smooth' });
      }
    }
  }

  customElements.define('rr-gallery', RRGallery);
})();
